/**
 * 轨道操作按钮组件
 */

import { InlineAction, InlineActionGroup } from './inline-action'

import type { TrackType, TrackStatus } from '@company/shared'

// ==================== 类型定义 ====================

interface TrackActionsProps {
  track: TrackType
  status: TrackStatus
  onStart?: () => void
  onSubmit?: () => void
  onApprove?: () => void
  onReject?: () => void
  startLoading?: boolean
  submitLoading?: boolean
  approveLoading?: boolean
  rejectLoading?: boolean
  className?: string
}

// ==================== 组件实现 ====================

export function TrackActions({
  track: _track,
  status,
  onStart,
  onSubmit,
  onApprove,
  onReject,
  startLoading = false,
  submitLoading = false,
  approveLoading = false,
  rejectLoading = false,
  className,
}: TrackActionsProps) {
  // 已跳过或已通过的轨道不显示操作
  if (status === 'skipped' || status === 'approved') {
    return null
  }

  return (
    <InlineActionGroup className={className}>
      {/* 待开始 -> 开始开发 */}
      {status === 'pending' && onStart && (
        <InlineAction label="开始" onClick={onStart} variant="primary" loading={startLoading} />
      )}

      {/* 开发中 -> 提交审查 */}
      {status === 'in_progress' && onSubmit && (
        <InlineAction
          label="提交审查"
          onClick={onSubmit}
          variant="primary"
          loading={submitLoading}
        />
      )}

      {/* 审查中 -> 通过/拒绝 */}
      {status === 'in_review' && (
        <>
          {onApprove && (
            <InlineAction
              label="通过"
              onClick={onApprove}
              variant="success"
              loading={approveLoading}
            />
          )}
          {onReject && (
            <InlineAction
              label="驳回"
              onClick={onReject}
              variant="danger"
              loading={rejectLoading}
            />
          )}
        </>
      )}
    </InlineActionGroup>
  )
}

/**
 * 轨道操作配置生成器
 * 根据轨道状态生成可用的操作
 */
export function getTrackActionConfig(status: TrackStatus) {
  return {
    canStart: status === 'pending',
    canSubmit: status === 'in_progress',
    canApprove: status === 'in_review',
    canReject: status === 'in_review',
    isCompleted: status === 'approved' || status === 'skipped',
  }
}
